export enum FilterConfigFormat {
  EstateFilterType = 'EstateFilterType',
  Criteria = 'Criteria',
}
